import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';

@Component({
    selector: 'app-stock-home',
    imports: [MenuCommonComponent],
    templateUrl: './stock-home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './stock-home.component.scss'
})
export class StockHomeComponent {

}
